import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Link, RouteComponentProps } from '@reach/router';
import { PolicyStreamAdvisors } from './PolicyStreamAdvisors';
import { PolicyStreamInsuranceCompanies } from './PolicyStreamInsuranceCompanies';

interface PolicyStreamAdminHubProps extends RouteComponentProps {}

export const PolicyStreamAdminHub = (_props: PolicyStreamAdminHubProps) => {
  return (
    <HubRoot>
      <Typography variant='h4' component='h1' gutterBottom>
        PolicyStream administration
      </Typography>

      <NavBlock>
        <Typography variant='subtitle1' component='p'>
          Data tools
        </Typography>
        <AdminNavList>
          <li>
            <HubLink to='plans'>PolicyStream plans (table)</HubLink>
          </li>
          <li>
            <HubLink to='compulifecalls'>Compulife API calls</HubLink>
          </li>
        </AdminNavList>
      </NavBlock>

      <PolicyStreamAdvisors />
      <PolicyStreamInsuranceCompanies />
    </HubRoot>
  );
};

const HubRoot = styled('div')(({ theme }) => {
  return { padding: theme.spacing(1, 0) };
});

const NavBlock = styled('nav')(({ theme }) => {
  return {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
  };
});

const AdminNavList = styled('ul')(({ theme }) => {
  return {
    margin: theme.spacing(1, 0, 0, 0),
    paddingLeft: theme.spacing(3),
  };
});

const HubLink = styled(Link)(({ theme }) => {
  return {
    fontWeight: 600,
    color: theme.palette.primary.main,
  };
});
